import { decrypt } from "../../utils/crypto";
import {
  LOGIN_BEGINS,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  TURNOFF_LOADER,
} from "../constants/auth";
import { SET_REFRESH_AG_TABLES } from "../constants/customers";


const token =  (localStorage.getItem("token") && decrypt(localStorage.getItem("token")));
const superAdminAuth = (localStorage.getItem("super-admin-auth") && decrypt(localStorage.getItem("super-admin-auth")))

let user = token ?token :superAdminAuth

if (user?.error) {
  user = {
    authToken: "",
    email: "",
    first_name: "",
    last_name: "",
    profile_pic: "",
  };
}

const authState = {
  googleAuthenticate: false,
  user: user || {},
  logoutLoader: false,
  welcomeScreenLoader: true,
  tableRefresh: false,
};

export const authReducer = (state = authState, action) => {
  switch (action.type) {
    case LOGIN_BEGINS:
      return { ...state, googleAuthenticate: true };
    case LOGIN_SUCCESS:
      return { ...state, googleAuthenticate: false, user: action.data };
    case LOGIN_FAILURE:
      return { ...state, googleAuthenticate: false };
    case TURNOFF_LOADER:
      return { ...state, welcomeScreenLoader: false };
    case SET_REFRESH_AG_TABLES:
      return { ...state, tableRefresh: action.data };
    case LOGOUT_SUCCESS:
      return { ...state, user: {} };
    default:
      return { ...state };
  }
};
